import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import Age from "../components/Age.vue";
import Policy from "../components/Policy.vue";
import Health from "../components/Health.vue";
import Issues from "../components/Issues.vue";
import WebToLead from "../components/WebToLead.vue";
import NotQualified from "../views/NotQualified.vue";
//import Qualified from "../views/Qualified.vue";
import Estimate from "../views/Estimate.vue";
import Numbers from "../components/RunNumbers.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "index", component: Index },
  { path: "/age", name: "age", component: Age },
  { path: "/policy", name: "policy", component: Policy },
  { path: "/health", name: "health", component: Health },
  { path: "/issues", name: "issues", component: Issues },
  { path: "/numbers", name: "numbers", component: Numbers },
  { path: "/wtl", name: "wtl", component: WebToLead },
  { path: "/estimate", name: "estimate", component: Estimate },
  { path: "/not-qualified", name: "not-qualified", component: NotQualified },
  /*{ path: "/qualified", name: "qualified", component: Qualified },*/
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

export default router;
